// Vendors
import jquery from 'jquery/dist/jquery.js';

// Modules
import faculty from '../modules/faculty.js';
import photo from '../modules/photo-carousel.js';

// Styles
import about from '../../css/pages/about-us.scss';